import { db } from "../../firebase";

const state = {
    userInfo: true,
    physicalInfo: true,
    familyHistory: true,
    bloodTestResult: true,
    lifeStyle: true
}

const mutations = {
    setUserInfo(state, payload) {
        state.userInfo = payload
    },
    setPhysicalInfo(state, payload) {
        state.physicalInfo = payload
    },
    setFamilyHistory(state, payload) {
        state.familyHistory = payload
    },
    setBloodTestResult(state, payload) {
        state.bloodTestResult = payload
    },
    setLifeStyle(state, payload) {
        state.lifeStyle = payload
    }
}

const actions = {
    setUserInfo({ commit }, payload) {
        commit('setUserInfo', payload)
    },
    setPhysicalInfo({ commit }, payload) {
        commit('setPhysicalInfo', payload)
    },
    setFamilyHistory({ commit }, payload) {
        commit('setFamilyHistory', payload)
    },
    setBloodTestResult({ commit }, payload) {
        commit('setBloodTestResult', payload)
    },
    setLifeStyle({ commit }, payload ) {
        commit('setLifeStyle', payload)
    }
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  };